import { UPDATE_CUSTOM_EVENT } from '@xzx-design/constants'
import {
  buildProps,
  makeNumericProp,
  makeStringProp,
  numericProp,
  truthProp,
} from '@xzx-design/utils'

import type { ExtractPropTypes, PropType } from 'vue'
import type Tabs from '../tabs'
import type {
  TabsClickTabEventParams,
  TabsStickyScrollParams,
  TabsType,
} from './index'
import type { Interceptor, Numeric } from '@xzx-design/utils'

export const tabsProps = buildProps({
  active: makeNumericProp(0),
  type: makeStringProp<TabsType>('line'),
  color: String,
  border: truthProp,
  sticky: Boolean,
  shrink: Boolean,
  duration: makeNumericProp(0.3),
  animated: Boolean,
  ellipsis: truthProp,
  swipeable: Boolean,
  scrollspy: Boolean,
  offsetTop: makeNumericProp(0),
  background: String,
  lazyRender: truthProp,
  showHeader: truthProp,
  lineWidth: {
    type: numericProp,
  },
  lineHeight: {
    type: numericProp,
  },
  beforeChange: {
    type: Function as PropType<Interceptor>,
  },
  swipeThreshold: makeNumericProp(5),
  titleActiveColor: String,
  titleInactiveColor: String,
})

export type TabsProps = ExtractPropTypes<typeof tabsProps>
export type TabsInstance = InstanceType<typeof Tabs>

export const tabsEmits = {
  [UPDATE_CUSTOM_EVENT('active')]: (value: Numeric) => true,
  change: (value: Numeric, title: string) => true,
  scroll: (value: TabsStickyScrollParams) => value,
  rendered: (name: Numeric, title?: string) => true,
  clickTab: (tab: TabsClickTabEventParams) => tab,
}

export type TabsEmits = typeof tabsEmits
